(function() {
	'use strict';
	
	angular.module('vhols')
	
		.directive('collapseSection', function() {
			return {
				scope: true,
				link: function($scope, $element, $attrs) {
					$scope.sectionOpen = false;
					var isDesktop = window.innerWidth >= vhols.mobileScreenWidth;
					
					if (isDesktop) {
						$scope.sectionOpen = $attrs.openDesktop ? JSON.parse($attrs.openDesktop) : false;
					} else if (!isDesktop) {
						$scope.sectionOpen = $attrs.openMobile ? JSON.parse($attrs.openMobile) : false;
					}
				}
			};
		});
})();